<template>
<div class="homepage">
    <FilterDatas 
      v-show="false"
      :collection="collection" 
      :mode="'prod'" 
      :model="['id', 'firstname', 'lastname', 'beaconId', 'tags']"
      :setQuery="queryFromSidebar"
      @filteredData="filteredLogs">
    </FilterDatas>
    
    <el-dialog
      class="custom-modal-size"
      title="Filter"
      width="1100px"
      :visible.sync="getFilterModalVisible">
      <FilterDatas 
        :collection="collection" 
        :mode="'prod'" 
        :model="['id', 'firstname', 'lastname', 'beaconId', 'tags']"
        :setQuery="queryFromSidebar"
        @filteredData="filteredLogs"></FilterDatas>
      <el-button @click="closeFilterModal">Fermer</el-button>
    </el-dialog>

    <el-card class="custom-margin-bottom ">
      <TopBarMiniCard
        :title="'Opérateurs'"
        :cardLoaded="collection.length"
        :isLoaded="'isAllOperatorsLoaded'"
        @clickLoadMore="loadMoreData"
        @refresh="refreshData"
        @createNew="createNew"
      ></TopBarMiniCard>
    </el-card>
    <CardMiniOperator v-for="(operator, idx) in filteredCollection" :key="idx" :operator="operator"></CardMiniOperator>
    
    <!-- start Modal for Create operator form -->
    <el-dialog
      width="1200px"
      :visible.sync="dialogFormVisible"
      :modalAppendToBody="false">
        <CreateOperatorModal :key="dialogFormVisible" @closeForm="closeCreationForm"></CreateOperatorModal>
    </el-dialog>
    <!-- end Modal for Create OF form -->
  </div>
</template>

<script>
import CardMiniOperator from '@/components/CardMiniOperator.vue'
import TopBarMiniCard from '../components/TopBarMiniCard.vue'
import FilterDatas from '@/components/vuejs-components-collection/components-collection/FilterDatas.vue'
import CreateOperatorModal from '../components/operator/CreateOperatorModal.vue'

export default {
  name: 'productionArea',
  components: {
    FilterDatas,
    CardMiniOperator,
    TopBarMiniCard,
    CreateOperatorModal
  },
  data() {
    return {
      filteredCollection: [],
      dialogFormVisible: false
    }
  },
  mounted() {
    if(this.$store.getters.operators.length === 0) {
      this.$store.dispatch('getOperators');
    }
    if(this.$store.getters.productionZones.length === 0) {
      this.$store.dispatch('getProductionZones');
    }
    if(this.$store.getters.manufacturingOrders.length === 0) {
      this.$store.dispatch('getManufacturingOrders');
    }
  },
  created() {
    this.filteredCollection = this.collection;
  },
  watch: {
    collection: function() {
      this.filteredCollection = this.collection;
    }
  },
  computed : {
    collection() {
      return this.$store.getters.operators
    },
    allLoaded() {
      return this.$store.getters.isAllOperatorsLoaded;
    },
    getFilterModalVisible: {
      get: function() {
        return this.$store.getters.getFilterModalVisible;
      },
      set: function() {
        return this.$store.dispatch('switchFilterModalVisible', false);
      }
    },
    queryFromSidebar() {
      return this.$store.getters.searchFavSelected;
    }
  },
  methods: {
    filteredLogs: function(event) {
      this.filteredCollection = event;
    },
    loadMoreData: function() {
      this.$store.dispatch('loadMoreOperators');
    },
    refreshData: function() {
      this.$store.dispatch('refreshOperators');
    },
    closeFilterModal: function() {
      this.$store.dispatch('switchFilterModalVisible');
    },
    createNew: function() {
      this.dialogFormVisible = true;
    },
    closeCreationForm: function() {
      this.dialogFormVisible = false;
    }
  }
}
</script>

<style lang="css" scoped>
  .homepage {
    min-width: 950px;
  }

  .custom-modal-size {
    margin: auto;
  }

  .custom-margin-bottom {
    margin-bottom: 20px;
  }

  .el-dialog {
    width: 1100px !important;
  }

</style>
